module.exports = __webpack_public_path__ + "static/media/oneHundred_118.a81f68a4.png";